import {
    SET_HAS_AVAILABLE_DEVICE,
    SET_IS_PLAYING,
    SET_IS_PLAYING_CAST,
    SET_VIDEO_DETAILS,
    SET_PLAYING_VIDEO_DETAILS,
    SET_AIRPLAY_AVAILABILITY,
    SET_AIRPLAY_CONNECTIVITY,
    SET_CAST_AVAILABILITY,
} from "./types";

const initialState = {
    native: {
        hasAvailableDevice: false,
        isPlaying: false,
        isPlayingCast: false,
        video: null,
        playingVideo: null,
        airplayAvailable: false,
        airplayConnected: false,
        castAvailable: false,
        castConnected: false,
    }
};

export default function (state = initialState, action) {

    switch (action.type) {
        case SET_CAST_AVAILABILITY:
            return {
                ...state,
                native: {
                    ...state.native,
                    castAvailable: action.bool
                }
            }
        case SET_AIRPLAY_CONNECTIVITY:
            return {
                ...state,
                native: {
                    ...state.native,
                    airplayConnected: action.bool
                }
            }
        case SET_AIRPLAY_AVAILABILITY:
            return {
                ...state,
                native: {
                    ...state.native,
                    airplayAvailable: action.bool
                }
            }

        case SET_HAS_AVAILABLE_DEVICE:
            return {
                ...state,
                native: {
                    ...state.native,
                    hasAvailableDevice: action.bool
                }
            }

        case SET_IS_PLAYING:
            return {
                ...state,
                native: {
                    ...state.native,
                    isPlaying: action.bool
                }
            }

        case SET_IS_PLAYING_CAST:
            return {
                ...state,
                native: {
                    ...state.native,
                    isPlayingCast: action.bool,
                    playingVideo: action.bool ? {
                        ...state.native.playingVideo,
                        video_id: (action?.video && action.bool) ? action?.video : state.native.playingVideo?.video_id
                    } : null
                }
            }

        case SET_VIDEO_DETAILS:
            return {
                ...state,
                native: {
                    ...state.native,
                    video: action.details
                }
            }

        case SET_PLAYING_VIDEO_DETAILS:
            return {
                ...state,
                native: {
                    ...state.native,
                    playingVideo: action.details
                }
            }

        default:
            return state;
    }
}